import React from 'react';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { advancedRoadmapsPlanPageInitialChecksResource } from '@atlassian/jira-router-resources-advanced-roadmaps-plan/src/services/index.tsx';
import { planExportPageRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-routes/src/planExportPageRoute.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { LazyAdvancedRoadmapsPlanExport } from './ui/plan-export/index.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';

/**
 * Export Page
 */

const ExportPageComponent = () => <LazyAdvancedRoadmapsPlanExport />;

const ExportPage = () => (
	<LazyPage Page={ExportPageComponent} pageId="advanced-roadmap" shouldShowSpinner />
);

export const planExportPageRouteEntry = createEntry(planExportPageRoute, () => ({
	group: 'software',
	ufoName: 'software-advanced-roadmaps-scenario-export',
	component: ExportPage,
	layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
	resources: [advancedRoadmapsPlanPageInitialChecksResource],
	forPaint: [LazyPlanTimeline],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planExportPageRouteEntry.tsx',
			whichExportToUse: 'planExportPageRouteEntry',
		},

		enabled: true,
	},
}));
